var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C12.1423 0.5 15.5 3.85775 15.5 8C15.5 12.1423 12.1423 15.5 8 15.5C3.85775 15.5 0.5 12.1423 0.5 8C0.5 3.85775 3.85775 0.5 8 0.5ZM8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2ZM8 3.5C8.1837 3.50002 8.361 3.56747 8.49828 3.68954C8.63556 3.81161 8.72326 3.97981 8.74475 4.16225L8.75 4.25V7.6895L10.7802 9.71975C10.9148 9.85472 10.9929 10.0358 10.9987 10.2263C11.0045 10.4167 10.9376 10.6023 10.8116 10.7452C10.6855 10.8881 10.5098 10.9777 10.3201 10.9958C10.1305 11.0139 9.94099 10.9591 9.79025 10.8425L9.71975 10.7802L7.46975 8.53025C7.35318 8.41358 7.27832 8.26175 7.25675 8.09825L7.25 8V4.25C7.25 4.05109 7.32902 3.86032 7.46967 3.71967C7.61032 3.57902 7.80109 3.5 8 3.5Z",
    fill: "#999EA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.b6bc690513a87b0831f99bd469a82bf3.svg";
export { ForwardRef as ReactComponent };